// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#grand-total.q-table td{font-weight:700!important;border-top:1px solid rgba(0,0,0,.12)!important;border-bottom:1px solid rgba(0,0,0,.12)!important}#grand-total.q-table th{visibility:hidden}#no-records.q-table{border-top:0!important}#report-card .sales-provider-summary-table table tr th{white-space:normal}", ""]);
// Exports
module.exports = exports;
